import { render, staticRenderFns } from "./SBBreadcrumb.html?vue&type=template&id=88d6e074&scoped=true&"
import script from "./SBBreadcrumb.ts?vue&type=script&lang=ts&"
export * from "./SBBreadcrumb.ts?vue&type=script&lang=ts&"
import style0 from "./SBBreadcrumb.css?vue&type=style&index=0&id=88d6e074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d6e074",
  null
  
)

export default component.exports